export default {
      id: "logic-cloud-logo-usage",
      viewBox: "0 0 56 48",
      url: "/dist/svg/" + "sprite.svg#logic-cloud-logo-usage",
      toString: function () {
        return this.url;
      }
    }